/* eslint-disable consistent-return, no-nested-ternary, indent */

import { AutocompleteFactory } from '@/commons/component/autocomplete';
import { getProductInfo, mapProductInfo, warn } from './utils';
import { getTemplate } from './templates';

const STORES_TO_LOAD = 200;
const STORES_TO_DISPLAY = 10;

/**
 *  Init StoreFinder module
 */
export class StoreFinder {
  constructor({ container, template = {}, product } = {}) {
    // check container
    if (!container) return warn('Bad instantiation : no container');

    // inner attributes
    this.container = container;
    this.containerStores = container.$('.js-sf__stores');
    this.template = template;
    this.product = product;
    this.countDisplayedStores = STORES_TO_DISPLAY;
    this.mapEvents = {};

    // Check container
    if (!this.containerStores)
      return warn('Bad instanciation : no container for stores');

    // this.initAutocomplete();
    if (cube.env.country === 'HK') {
      this.displayStoresWithoutSearch();
    } else {
      this.initAutocomplete();
    }

    // Bind 'see-more-stores' generic action
    this.onClick('.js-see-more', () => this.seeMoreStores(10));
  }

  /**
   *  Getter for currently displayed stores
   */
  get displayedStores() {
    if (this.stores && this.stores.length)
      return this.stores.slice(0, this.countDisplayedStores);
    return [];
  }

  /**
   *  Init Autocomplete module & handle actions
   */
  initAutocomplete() {
    const autocompleteElt = this.container.$('.js-sf__form');

    this.autocomplete = AutocompleteFactory(autocompleteElt);
    this.$form = this.container.$('.dkt-form');

    const input = this.container.$('.js-input');

    $(autocompleteElt).on('click', '.js-close', () => {
      this.countDisplayedStores = STORES_TO_DISPLAY;
      input.value = '';
      this.removeStores();
      if (this.$form)
        this.$form.classList.remove('store-selection__search-form--flushable');
    });

    // handle SELECT a PLACE
    this.autocomplete.on('select', place => {
      this.countDisplayedStores = STORES_TO_DISPLAY;
      // make input loading
      if (this.$form)
        this.$form
        .classList.add('store-selection__search-form--loading');
      this.getStores({
        // build params to request stores around lat/lng place's position
        lat: place.latitude,
        lng: place.longitude,
        stores_by_page: STORES_TO_LOAD,
      }, stores => this.emit('stores', stores));
    });

    // // handle Autocomplete CHANGE (debounced)
    // // -- remove STORES in all case when suggestions are refreshed
    this.autocomplete.on('suggest', () => {
      this.removeStores();
    });

    // handle Autocomplete CHANGE (not debounced)
    // -- change SEARCH / DELETE icon
    // -- remove STORES if input length < 3
    input.addEventListener('input', () => {
      // ICON
      if (input.value.length >= 1 && this.$form)
        this.$form
          .classList.add('store-selection__search-form--flushable');
      if (input.value.length === 0 && this.$form)
        this.$form
          .classList.remove('store-selection__search-form--flushable');
      // Remove STORES
      if (input.value.length < 3) this.removeStores();
    });
  }

  /**
   *  Get STORES based on parameters
   *  -- calls woosmap:stores/search API
   */
  getStores(params, callback) {
    cube.stores.getStores(params, stores => {
      if (stores && stores.length) {
        // persist stores
        this.stores = stores.map(store => store.properties);
        this.geometries = stores.map(store => store.geometry);

        if (this.product)
          // we have to get product-information
          this.getProductInfo();
        else
          // we can render the store list directly
          this.displayStore(this.displayedStores.map(s => ({ store: s })));

        if (typeof callback === 'function') callback(stores);
      } else {
        // No STORES : display error message
        this.displayError();
        // remove input loading
        if (this.$form)
          this.$form
          .classList.remove('store-selection__search-form--loading');
      }
    });
  }

  /**
   *  Get PRODUCT INFO based on product ids
   *  -- calls cube:ajax/getStoreAvailability API
   */
  getProductInfo() {
    //
    const idModel = this.product.idModel();
    const idSku = this.product.idSku();

    // Get ProductInfo for all needed stores
    getProductInfo(idModel, idSku, this.displayedStores.map(s => s.store_id))
      .then(productInfo => {
        this.displayStore(
          // for each stores ...
          this.displayedStores.map(s => ({
            store: s,
            // ... returns the associated productInfo
            productInfo: productInfo[s.store_id],
          }))
        );
      })
      .catch(() => this.displayError());
  }


  /**
   *  Event delegation inside Store Finder
   *    -- storeFinder.onClick('.my-button', ( { element, event , store , product } ) => { ... })
   */
  onClick(selector, callback) {
    this.on('click', selector, callback);
  }


  emit(event, ...args) {
    if (this.mapEvents[event])
      this.mapEvents[event].forEach(callback => callback(...args));
  }
  on(trigger, selector, callback) {

    if (trigger !== 'click') {
      // handle custom event
      if (!this.mapEvents[trigger]) this.mapEvents[trigger] = [];
      this.mapEvents[trigger].push(callback || selector);
      return;
    }


    const self = this;
    $(self.container).on(trigger, selector, function cbOnClick(event) {
      // Check for a STORE ID
      const idStore = event.target.dataset.idStore
        ? // current element has [data-store-id]
          event.target.dataset.idStore
        : event.target.closest('[data-id-store]')
          ? // a surrounding element has [data-store-id]
            event.target.closest('[data-id-store]').dataset.idStore
          : null;

      // Retrieve STORE -- or null
      const storeIndex = self.stores.findIndex(s => s.store_id === idStore);
      const store = storeIndex > -1 ? self.stores[storeIndex] : null;
      const geometry = storeIndex > -1 ? self.geometries[storeIndex] : null;

      // Retrieve PRODUCT-INFO -- or null
      const productInfo =
        self.product && idStore
          ? mapProductInfo[self.product.idModel()][self.product.idSku()][
              idStore
            ]
          : null;

      // Return DATA
      callback({
        event,
        store,
        geometry,
        productInfo,
        element: this,
      });
    });
  }

  /**
   *  display a list of stores
   *  -- data = [ { store: {}, product: {} }, { store: {}, product: {} }, ... ]
   */
  displayStore(data = []) {
    // remove previous store
    this.removeStores();
    // remove input loading
    if (this.$form)
        this.$form
      .classList.remove('store-selection__search-form--loading');

    // redisplay container to show elements in
    this.containerStores.classList.add('filled-list');

    // append each stores to containerStores
    this.containerStores.innerHTML = data
      .map(
        typeof this.template === 'function'
          ? this.template // template function
          : getTemplate(this.template || 'default') // pre-built template -- or default
      )
      .join('');

    // prepend HEADER to containerStores
    this.containerStores.insertAdjacentHTML(
      'beforebegin',
      `<h3 class="store-selection__list-title js-store-result">
        ${window.Messages('storeselection.storeListTitle', data.length)}
      </h3>`
    );

    // prepend SEE MORE STORES if needed
    const btnSeeMoreStore = cube.$('.store-selection__more-stores');
    if (this.stores.length > data.length && !btnSeeMoreStore)
      this.containerStores.insertAdjacentHTML(
        'afterend',
        `<div class="store-selection__more-stores">
          <button class="cta-v2 cta-v2--s cta-v2--alt dkti-edit-plus js-see-more">
            ${window.Messages('storeselection.seeMore')}
          </button>
        </div>`
      );
    else if (data.length >= this.stores.length && btnSeeMoreStore)
      btnSeeMoreStore.remove();
  }

  seeMoreStores(number = 0) {
    this.countDisplayedStores =
      this.countDisplayedStores + (number === 0 ? 0 : STORES_TO_DISPLAY);
    if (this.$form)
      this.$form
      .classList.add('store-selection__search-form--loading');
    if (this.product) this.getProductInfo();
    else this.displayStore(this.displayedStores.map(s => ({ store: s })));
  }

  /**
   *  clear store results
   */
  removeStores() {
    // REMOVE STORES list
    this.containerStores.innerHTML = '';
    // undisplay when the container is empty
    this.containerStores.classList.remove('filled-list');
    // REMOVE TITLE
    if (cube.$('.store-selection__list-title'))
      cube.$$('.store-selection__list-title').forEach(e => {
        e.outerHTML = '';
      });
    if (cube.$('.store-selection__more-stores'))
      cube.$('.store-selection__more-stores').outerHTML = '';
  }

  /**
   *  display an generic error message
   */
  displayError() {
    const parent = this.containerStores.parentNode;
    // Display error if not already there
    if (!parent.$('.store-selection__error-message')) {
      parent.insertAdjacentHTML(
        'beforeend',
        `<p class="store-selection__error-message">${window.Messages(
          'storeselection.errorMessage'
        )}</p>`
      );
    }
  }

  displayStoresWithoutSearch() {
    const el = cube.$('.store-selection');
    cube.ui.displayLoader(el);
    this.getStores({}, (stores) => {
      if (stores) {
        cube.ui.hideLoader(el);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/commons/component/store-finder/index.js